<template>
  <div class="fc jc ac p40">
    <img class="cert-img" :src="cert_img" alt />

    <!-- <div class="mt20" style="font-size:12px" v-if="money>=200 ">捐款≥200元区红会将为您准备纸质证书，捐款证书与捐款收据如有需要，请自行前往区红十字会领取。</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      cert_img: "",
      money: ""
    };
  },
  mounted() {
    let param = this.$route.query;
    this.cert_img = "http://img.baoshanhszh.cn/" + param.cert_img + ".png";
    this.money = param.money;
    console.log(param);
  }
};
</script>
<style lang="less" scoped>
.cert-img {
  width: 350px;
  height: 486px;
}
</style>